// frontend/src/components/JsonModal.tsx
import type React from "react";

interface JsonModalProps {
  isOpen: boolean;
  jsonData: string;
  onClose: () => void;
}

const handleCopyToClipboard = (data: string) => {
  navigator.clipboard
    .writeText(data)
    .then(() => {
      alert("JSON copied to clipboard!");
    })
    .catch((err) => {
      console.error("Failed to copy: ", err);
    });
};

const JsonModal: React.FC<JsonModalProps> = ({ isOpen, jsonData, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "5px",
          width: "80%",
          maxWidth: "600px",
        }}
      >
        <h2>Export JSON</h2>
        <pre style={{ maxHeight: "300px", overflowY: "auto" }}>{jsonData}</pre>
        <div style={{ marginTop: "20px", textAlign: "right" }}>
          <button
            onClick={(e) => handleCopyToClipboard(jsonData)}
            style={{
              marginRight: "10px",
              backgroundColor: "#2196F3",
              color: "white",
            }}
          >
            Copy to Clipboard
          </button>
          <button onClick={onClose} style={{ marginLeft: "10px" }}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default JsonModal;
